import { useState } from 'react';
import ProfileDefaultImage from '../../../../images/profileDefault.png';
import { OfficeSearch } from './OfficeSearch';

export const EmptyOffice = ({ officeList, onSelectOffice }) => {
  const [showSearchField, setShowSearchField] = useState(false);

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
      }}
    >
      <img
        src={ProfileDefaultImage}
        alt="tooth"
        className="card-img-top mb-2"
        style={{
          objectFit: 'cover',
          width: '100px',
          height: '100px',
          borderRadius: 50,
          boxShadow: '0px 2px 3px rgba(0, 0, 0, 0.3)',
        }}
      />
      {showSearchField ? (
        <OfficeSearch officeList={officeList} onSelectOffice={onSelectOffice} />
      ) : (
        <button
          type="button"
          className="btn btn-light border border-info mt-2"
          style={{
            height: 150,
            width: '80%',
            borderRadius: 11,
          }}
          onClick={() => setShowSearchField(true)}
        >
          + Add a Dental Office
        </button>
      )}
    </div>
  );
};
